module.exports = `
qhmidwestfb|/healers?address=&bounds=52.32165921%2C-81.02112791%2C36.38558103%2C-100.03521269&mapSearch=true
qhmidatlanticfb|/healers?address=&bounds=40.98488256%2C-74.00741069%2C36.60318983%2C-78.76093189&mapSearch=true
qhtherapistsfb|/healers?pub_modalities=has_any%3Apsychotherapy-counseling
`;
